import React from 'react';
import withIcon from '../utilities/withIcon';

const IconVideoStart = () => {
  return (
    <g>
      <path d="m14.5405.2314a.7509.7509 0 0 0 -.75 0l-11.206 6.4697v-5.8202a.75.75 0 0 0 -1.5 0v14.2382a.75.75 0 0 0 1.5 0v-5.82l11.206 6.47a.75.75 0 0 0 1.125-.6494v-14.2388a.75.75 0 0 0 -.375-.6495zm-1.125 13.5886-10.081-5.82 10.081-5.82z" />
    </g>
  );
};

export default withIcon(IconVideoStart);
